module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iOCIgY3k9IjEwIiByPSI4IiBmaWxsPSIjRDVFRERCIi8+CjxjaXJjbGUgY3g9IjgiIGN5PSIxMCIgcj0iNSIgZmlsbD0iIzRGQTQ2MiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/iconLink.svg
// module id = eQ3c
// module chunks = 0